<template>
  <span @click="fnClick(data)" v-show="data" 
    ><el-tag class="tag-pimary">{{ data }}</el-tag></span>
</template>

<script>
import { Tag, Form } from 'element-ui';

export default {
  props: ['data'],
  data() {
    return {};
  },
  components: {
    [Tag.name]: Tag,
    [Form.name]: Form,
  },
  methods: {
    fnClick(item) {
      this.$emit('fnSendRef', item);
    },
  },
};
</script>
<style>
span.el-tag.tag-pimary {
  cursor: pointer;
  padding: 0 12px;
  height: 40px;
  line-height: 39px;
  font-size: 20px;
  margin-bottom: 8px;
  margin-right: 12px;
  background: #ecf5ff;
  color: #409eff;
  border-color: #b3d8ff;
}
</style>



// WEBPACK FOOTER //
// src/components/listRef.vue